// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { CLIENT_VERIFICATION_UPDATE } from '../../../../../common/constant'
import { post } from '../../../../../common/api'

export const actionUpdateClient = createAsyncThunk('clientUpdateStore/actionUpdateClient', async (params, thunkAPI) => {
    return await post(CLIENT_VERIFICATION_UPDATE, params, thunkAPI)
})


export const clientUpdateSlice = createSlice({
    name: 'clientUpdateStore',

    initialState: {
        clientUpdate: null,
        loadingClientUpdate: false,
    },
    reducers: {
        //reset or delete public store data
        resetClientUpdateResponse: (state) => {
            state.clientUpdate = null
        }
    },
    extraReducers: builder => {
        builder
            //client update
            .addCase(actionUpdateClient.pending, (state) => {
                state.loadingClientUpdate = true
            })
            .addCase(actionUpdateClient.fulfilled, (state, action) => {
                state.loadingClientUpdate = false
                state.clientUpdate = action.payload
            })
            .addCase(actionUpdateClient.rejected, (state) => {
                state.loadingClientUpdate = false
            })
    }
})
export const { resetClientUpdateResponse } = clientUpdateSlice.actions

export default clientUpdateSlice.reducer